import * as yup from 'yup';
import { noSpaceAllowedInSchemaTest, themeObject } from '../../../../lib';

export interface CreateExportDataJobFormInputs {
    chain: string;
    password?: string;
}

export const createExportDataJobSchema = yup.object({
    chain: yup.string().required(),
    password: noSpaceAllowedInSchemaTest(
        yup.string().optional(),
        'Enter a valid password.'
    ),
});

export const createExportDataJobDefaults = { chain: '' };

export const createExportJobStyles = {
    mainContainerStyles: {
        display: 'flex',
        flexDirection: 'column',
        mx: '143.5px',
        '&::-webkit-scrollbar': { width: '8px' },
        '&::-webkit-scrollbar-track': {
            display: 'none',
        },
        '&::-webkit-scrollbar-thumb': {
            background: themeObject.palette.primary[500],
            borderRadius: '100px',
        },
        '& .MuiDialog-container': {
            backgroundColor: 'rgb(249,251,251)',
        },
    },
    executingAsContainerStyles: {
        width: '100%',
        mt: 3,
    },
    passwordContainerStyles: {
        width: '100%',
        mt: 2,
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    chainSelectFieldStyles: {
        mx: 0,
        mt: 2,
    },
};
